<template>
  <b-navbar-item tag="div">
    <b-dropdown
      scrollable
      max-height="400px"
      position="is-bottom-left"
      aria-role="menu"
    >
      <a slot="trigger" class="navbar-item" role="button">
        <b-icon pack="fas" icon="bell" :type="iconType"></b-icon>
        <span v-if="unseenCount" class="is-size-7">{{ unseenCount }}</span>
      </a>
      <b-dropdown-item v-if="unseenCount === 0" custom aria-role="menuitem">
        <p class="has-text-grey has-text-centered">No notifications</p>
      </b-dropdown-item>
      <template v-for="notification in notifications">
        <b-dropdown-item custom aria-role="menuitem" :key="notification.guid">
          <div class="media notification-media">
            <b-icon
              class="media-left"
              pack="fas"
              :icon="icon(notification.notificationType)"
            />
            <div class="media-content">
              <NotificationText :notification="notification" />
            </div>
            <a
              title="Dismiss"
              class="is-pulled-right"
              @click="dismiss(notification.guid)"
            >
              <b-icon pack="fas" icon="times" type="is-grey" size="is-medium" />
            </a>
            <b-loading
              :is-full-page="false"
              :active="dismissing[notification.guid]"
            />
          </div>
        </b-dropdown-item>
        <hr class="dropdown-divider" :key="'divider-' + notification.guid" />
      </template>
    </b-dropdown>
  </b-navbar-item>
</template>

<script>
import dataService from "../../services/dataService";
import NotificationText from "./NotificationText";

export default {
  components: { NotificationText },
  data() {
    return {
      notifications: [],
      polling: null,
      dismissing: {}
    };
  },
  computed: {
    unseenCount() {
      return this.notifications.filter(n => !n.seen).length;
    },
    iconType() {
      return this.unseenCount > 0 ? "is-info" : "";
    }
  },
  methods: {
    async fetchNotifications() {
      this.notifications = await dataService.getNotifications();
    },
    async dismiss(notificationGuid) {
      this.$set(this.dismissing, notificationGuid, true);
      await dataService.dismissNotification(notificationGuid);
      await this.fetchNotifications();
    },
    pollNotifications() {
      this.polling = setInterval(this.fetchNotifications, 60000);
    },
    icon(notificationType) {
      switch (notificationType) {
        case "Praise":
          return "star";
        case "Feedback":
          return "comment-alt";
        case "SharedRecording":
          return "share-alt";
        default:
          break;
      }
    }
  },
  async created() {
    await this.fetchNotifications();
    this.pollNotifications();
  },
  beforeDestroy() {
    clearInterval(this.polling);
  }
};
</script>

<style lang="scss" scoped>
.notification-media {
  width: 350px;
  align-items: center;
}
</style>
